import React from 'react';

import { Header } from 'layouts/Header';
import { Layout } from 'layouts/Layout';
import { ContentWithNavigation } from 'layouts/wrappers/ContentWithNavigationWrapper';

import { PartnersZoneNavigation } from 'features/PartnersZone';
import { UserTableWithToolbar } from 'features/Users';

export const UsersPage: React.FC = () => (
	<Layout
		header={<Header />}
		main={
			<ContentWithNavigation
				tabsNavigation={<PartnersZoneNavigation />}
				content={<UserTableWithToolbar />}
			/>
		}
	/>
);
